import throttle from "helpers/lodash/throttle"
import { recoverScollPosition, saveScrollPosition } from "helpers/scrollSaver"
import { useCallback, useEffect } from "react"

export function useScrollPositionSaver(pageId) {
  const onScroll = useCallback(() => {
    saveScrollPosition(pageId)
  }, [])

  const onScrollThrottled = useCallback(throttle(onScroll, 300), [])

  useEffect(() => {
    recoverScollPosition(pageId)
    window.addEventListener("scroll", onScrollThrottled)

    return () => {
      window.removeEventListener("scroll", onScrollThrottled)
    }
  }, [])
}
